import React from 'react'
import Select from '../forms/redux-select'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

export default ({
  fields: {
    areaIds
  },

  areas,

  handleSubmit,
  handleClose,
  modalTitle,
  submitButtonText
}) => (
  <BaseModal
    onClose={handleClose}
    title={modalTitle}
    constraints={constraints}
    contentClassName='work-orders-create-container'
  >
    <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
      <ModalFormRow>
        <ModalFormBlock>
          <label htmlFor='location'>select room(s)</label>
          <Select multi options={areas} {...areaIds} />
        </ModalFormBlock>
      </ModalFormRow>
      <ModalFormRow>
        <ModalFormBlock submitButton>
          <button type='submit'>{submitButtonText || 'Submit'}</button>
        </ModalFormBlock>
      </ModalFormRow>
    </ModalForm>
  </BaseModal>
)



// WEBPACK FOOTER //
// ./src/components/qa-servicings/qa-servicing-multi-form.js